import {useEffect, useState} from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Card,CardBody,CardHeader } from 'reactstrap';
import {HiPencil} from 'react-icons/hi';
import {Button, IconButton} from '@mui/material';
import { DataCertificado } from '../../interfaces/Certificados';
import { MdFileOpen } from "react-icons/md";

interface Column {
    id: 'codigo' | 'fechaemision' | 'cedula' | 'nombre' | 'opcion';
    label: string;
    minWidth?: number;
    align?: 'right';
    format?: (value: number) => string;
    
  }

  const columns: readonly Column[] = [
    { 
        id: 'codigo', 
        label: 'Código', 
     },
     { 
        id: 'cedula', 
        label: 'Identificación', 
     },
     { 
        id: 'nombre', 
        label: 'Nombre Dirigido', 
     },
    {
      id: 'fechaemision',
      label: 'Fecha de emisión',
    },
    {
        id: 'opcion',
        label: 'Opciones',
    }
  ];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
    border: 0,
    },
}));


export default function CertificadosTable(props: DataCertificado){
    let history = useNavigate()
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage[0]);
    const [globalFilter, setGlobalFilter] = useState('');
    const constFilteredCert = props.data.filter((certificado) => {
        if (certificado.codigo.toUpperCase().includes(globalFilter.toUpperCase()) || certificado.cedulaDirigido.toUpperCase().includes(globalFilter.toUpperCase()) || certificado.nombrecompletoDirigido.toUpperCase().includes(globalFilter.toUpperCase()) || certificado.fechasolicitud.toUpperCase().includes(globalFilter.toUpperCase())) {
            return true;
        }
            return false;
        });

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    function rutaArchivoAntiguo(certificado: string):string{
        const parteAQuitar = "C:\\Sitios\\ws\\InvestigacionApi\\CERTIFICADOS\\";
        const resultado = certificado.replace(parteAQuitar, 'https://gestionproyectos.espol.edu.ec/CERTIFICADOS/');
        //const rutaOld = 'https://gestionproyectos.espol.edu.ec/CERTIFICADOS/'+certificado;
        //console.log(resultado)
        return resultado;
    } 

    const abrirVentana = (ruta:string) => {
        // Abre una nueva ventana con la URL especificada
        const old = "Sitios";
        if(ruta.includes(old)){
            window.open(rutaArchivoAntiguo(ruta), '_blank');
        }else{
            window.open(ruta, '_blank');
        }
      };
    

    const goToNavigation = (site:string) =>{
        history(site)
    }
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <Card>
                
            <CardBody>
                <div >
                    <div className='my-2 text-right'>
                        <input type="text" className='p-2 text-gray-600 border border-gray-300 rounded outline-indigo-700' placeholder='Buscar...' 
                            onChange={e=>setGlobalFilter(e.target.value)}
                        />
                    </div>
                </div>
            <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader aria-label="sticky table" >
                <TableHead>
                <TableRow>
                {columns.map((column) => (                
                    <StyledTableCell 
                            style={{ minWidth: column.minWidth }}
                            key={column.id}
                            align={column.align}>
                        {column.label}
                        </StyledTableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody>
                {constFilteredCert.length > 0 ? constFilteredCert
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                    return (
                        <StyledTableRow key={row.codigo}>
                            
                            <StyledTableCell align="left">{row.codigo}</StyledTableCell>
                            <StyledTableCell align="left">{row.cedulaDirigido}</StyledTableCell>
                            <StyledTableCell align="left">{row.nombrecompletoDirigido}</StyledTableCell>
                            <StyledTableCell align="left">{row.fechasolicitud.length > 0 ? row.fechasolicitud.split(" ")[0] : ""}</StyledTableCell>
                            <StyledTableCell align="left">
                                <IconButton color='info' onClick={() => abrirVentana(row.ruta)}><MdFileOpen /></IconButton>
                            </StyledTableCell>
                            </StyledTableRow>
                        );
                    }):
                    <StyledTableRow key={0}>
                        <StyledTableCell align="center"></StyledTableCell>
                        <StyledTableCell align="center"></StyledTableCell>
                        <StyledTableCell align="center">No se encontraron certificados</StyledTableCell>
                        <StyledTableCell align="center"></StyledTableCell>
                        <StyledTableCell align="center"></StyledTableCell>  
                    </StyledTableRow>
                    }
                </TableBody>
            </Table>
            </TableContainer>
            <TablePagination
            rowsPerPageOptions={props.rowsPerPage}
            component="div"
            count={constFilteredCert.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </CardBody>
            </Card>      
        </Paper>
        );


}

